export default function (formate) {
  return function TransformResponse(target, property, descriptor) {
    return {
      ...descriptor,
      value(...args) {
        return new Promise((resolve, reject) => {
          descriptor.value.apply(this, args)
            .then((res) => {
              resolve(formate(res));
            })
            .catch((error) => reject(error));
        });
      },
    };
  };
}
